import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';

import { AgeRestrictionsForm, LegalSettingsTabs } from '../../../components';
import { Preloader, ToDashboardError } from '../../../components/ui';
import { useCurrentProject } from '../../../contexts/settings';
import { RouteParams } from '../../../routes/types';

const AgeRestrictions = ({ match }: RouteComponentProps): JSX.Element => {
  const { projectId } = match.params as RouteParams;
  const { currentProjectFetching, error } = useCurrentProject(projectId);

  if (currentProjectFetching) {
    return (
      <LegalSettingsTabs>
        <Preloader />
      </LegalSettingsTabs>
    );
  }

  if (error) {
    return <ToDashboardError error={error} pageName="age-restrictions_open" />;
  }

  return (
    <LegalSettingsTabs>
      <AgeRestrictionsForm projectId={projectId} />
    </LegalSettingsTabs>
  );
};

export default withRouter(AgeRestrictions);
